module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-between mt-4"
  }, [(_vm.showEditBtn) ? _c('button', {
    staticClass: "btn tertiary flex-all fs-smaller",
    on: {
      "click": _vm.openEditEvent
    }
  }, [_vm._v("\n      Edit\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showReservationsBtn) ? _c('button', {
    staticClass: "btn tertiary flex-all mx-1 fs-smaller",
    on: {
      "click": function($event) {
        return _vm.routeTo('reservationsEvent')
      }
    }
  }, [_vm._v("\n      Reservations\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showCanceledBtn) ? _c('button', {
    staticClass: "btn bg-color-6 lightest tertiary flex-all fs-smaller",
    on: {
      "click": _vm.showCanceledPopup
    }
  }, [_vm._v("\n        Canceled\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showBookingBtn) ? _c('button', {
    staticClass: "btn flex-all fs-smaller",
    class: _vm.bookButtonLook.classes,
    on: {
      "click": _vm.bookButtonPress
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bookButtonLook.label) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1d77d9e1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d77d9e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Links.vue
// module id = 1681
// module chunks = 0